// extracted by mini-css-extract-plugin
export const carouselWrap = "carousel-module--carouselWrap--W957Q";
export const leftArr = "carousel-module--leftArr--ICwgf";
export const rightArr = "carousel-module--rightArr--35TwY";
export const carouselContentWrap = "carousel-module--carouselContentWrap--Kl1z4";
export const carouselStretch = "carousel-module--carouselStretch--1R6p1";
export const dots = "carousel-module--dots--z-C6m";
export const dot = "carousel-module--dot--AxWSb";
export const active = "carousel-module--active--3YRmP";